import { useImmer } from "use-immer";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";
import { faCircleQuestion } from "@fortawesome/free-regular-svg-icons";

const Component = ({ vulnerablePans, onChange }) => {
  const newPanTemplate = { pan: "", merchantId: "", expirationMinutes: 30, isNew: true };
  const [data, updateData] = useImmer(vulnerablePans);
  const [vulnerablePansInfoOpen, setVulnerablePansInfoOpen] = useState(false);

  const handleInfoIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setVulnerablePansInfoOpen(!vulnerablePansInfoOpen);
  };

  useEffect(() => {
    updateData(vulnerablePans);
  }, [vulnerablePans]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addNewRow = () => {
    updateData((d) => {
      d.unshift({ ...newPanTemplate });
    });
  };

  const displayedPans = data.slice(0, 5);

  return (
    <>
      <h3>
        Vulnerable PANs <small>(latest 5 entries)</small>
        <span className="section-header-icons">
          <FontAwesomeIcon
            icon={faCircleQuestion}
            className="info-icon"
            onClick={handleInfoIconClick}
            title={vulnerablePansInfoOpen ? "Hide info" : "Show info"}
          />
        </span>
      </h3>

      {vulnerablePansInfoOpen && (
        <div className="info-box">
          <p>
            <strong>Vulnerable PAN</strong> is a card that has experienced a rejected authorization at a hotspot which was not followed by a successful transaction at the same merchant within 10 minutes.
          </p>
        </div>
      )}

      <table className="config-table table-with-button">
        <thead>
          <tr>
            <th>PAN</th>
            <th>Merchant</th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={() => addNewRow()}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {displayedPans.map((vp, index) =>
            vp.isNew ? (
              <tr key={`new-${index}`}>
                <td>
                  <input
                    type="text"
                    value={vp.pan}
                    onChange={(e) =>
                      updateData((d) => {
                        d[index].pan = e.target.value;
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={vp.merchantId}
                    onChange={(e) =>
                      updateData((d) => {
                        d[index].merchantId = e.target.value;
                      })
                    }
                  />
                </td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    className="icon-clickable"
                    onClick={() =>
                      updateData((d) => {
                        d.splice(index, 1);
                      })
                    }
                  />
                </td>
              </tr>
            ) : (
              <tr key={vp.id}>
                <td>{vp.pan}</td>
                <td>{vp.merchantId || "-"}</td>
                <td>
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    className="icon-clickable"
                    onClick={() =>
                      updateData((d) => {
                        d.splice(index, 1);
                      })
                    }
                  />
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
      <Link to="/dashboard/vulnerable-pans">View complete table</Link>
    </>
  );
};

export default Component;
